import GMaps from '../libs/gmaps/gmaps.min.js'
import MarkerClusterer from '@google/markerclustererplus'

export const agenciesPage = {
  situation_map: false,

  buildMap: function () {
    const $map = $('#map')
    const datas = {}
    const markers = []
    let map
    let center

    if ($('#region').length) { datas.region = $('#region').val() }
    if ($('#department').length) { datas.department = $('#department').val() }

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/nos-agences/listing',
      data: datas,
      success: function (response) {
        let countAgencies = 0
        let infowindow
        const boxList = []
        let marker
        const icon = '/assets/img/icons/map-marker-37x45.png'

        // affiche les agences
        if (typeof (response.agencies) !== 'undefined') {
          /* global google */
          center = new google.maps.LatLng(49.8923598, 2.2951041)
          map = new google.maps.Map($map[0], {
            zoomControl: true,
            center: center,
            scrollwheel: false,
            streetViewControl: false,
            panControl: false,
            mapTypeControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            keyboardShortcuts: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
              {
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f5f5f5'
                  }
                ]
              },
              {
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off'
                  }
                ]
              },
              {
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#1872ae'
                  }
                ]
              },
              {
                elementType: 'labels.text.stroke',
                stylers: [
                  {
                    color: '#f5f5f5'
                  }
                ]
              },
              {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#bdbdbd'
                  }
                ]
              },
              {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#eeeeee'
                  }
                ]
              },
              {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#757575'
                  }
                ]
              },
              {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#e5e5e5'
                  }
                ]
              },
              {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#9e9e9e'
                  }
                ]
              },
              {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#ffffff'
                  }
                ]
              },
              {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#757575'
                  }
                ]
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#dadada'
                  }
                ]
              },
              {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#616161'
                  }
                ]
              },
              {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#9e9e9e'
                  }
                ]
              },
              {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#e5e5e5'
                  }
                ]
              },
              {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#eeeeee'
                  }
                ]
              },
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#c9c9c9'
                  }
                ]
              },
              {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#9e9e9e'
                  }
                ]
              }
            ]
          })
        }

        $.each(response.agencies, function (i, elem) {
          countAgencies++
          const boxText = document.createElement('div')
          boxText.id = i
          boxText.data = elem
          boxText.innerHTML = '<div class="text-center text-fixed" id="content"><span class="h6 text-uppercase">' + elem.link + '</span><span class="my-2 d-block">' + elem.address + '</span>' + elem.phone + '<br>' + elem.btn + '</div>'
          boxList.push(boxText)

          infowindow = new google.maps.InfoWindow({
            // content: '<div class="text-center" id="content"><span class="h6 text-uppercase"> ' + elem.link + '</span><br>' + elem.address + '<br>' + elem.phone + '</div>'
            enableEventPropagation: true
          })
          marker = new google.maps.Marker({
            id: i,
            position: new google.maps.LatLng(elem.lat, elem.lon),
            icon: icon,
            title: elem.name,
            address: elem.address,
            textColor: '#ffffff'
          })
          markers.push(marker)
          google.maps.event.addListener(marker, 'click', (function (marker) {
            // document.location.href = '/agences/'
            return function () {
              infowindow.setContent(boxList[this.id])
              infowindow.open(map, marker)
            }
          })(marker, i))
        })

        const c = '#eee'
        const s = '20'
        const f = 'Sen'
        const w = '400'
        const u = '/assets/img/icons/'
        const clusterStyles = [
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-52x51.png',
            height: 52,
            width: 51,
            anchorText: [1, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-56x55.png',
            height: 56,
            width: 55,
            anchorText: [3, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-65x64.png',
            height: 65,
            width: 64,
            anchorText: [6, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-78x77.png',
            height: 78,
            width: 77,
            anchorText: [12, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm90x89.png',
            height: 90,
            width: 89,
            anchorText: [15, 0],
            fontWeight: w
          }
        ]

        // dessine la carte ou affiche un message
        if (countAgencies > 0) {
          const m = new MarkerClusterer(map, markers, {
            styles: clusterStyles
            // imagePath: 'assets/img/icons/m',
          })
          // m.fitMapToMarkers()
          let listener
          if (countAgencies === 1) {
            listener = google.maps.event.addListener(map, 'idle', function () {
              // if (map.getZoom() > 16) map.setZoom(12)
              m.fitMapToMarkers()
              map.setZoom(10)
              google.maps.event.removeListener(listener)
            })
          } else {
            listener = google.maps.event.addListener(map, 'idle', function () {
              m.fitMapToMarkers()
              // map.setZoom(8)
              google.maps.event.removeListener(listener)
            })
          }
        }
      }
    })
  },

  init: function () {
    const $map = $('#map')
    const $mapD = $('#map-detail')
    const _this = this
    if ($map.length) {
      $map.waypoint(function () {
        _this.buildMap()
        this.destroy()
      }, {
        offset: '100%'
      })
    } else if ($mapD.length) {
      $mapD.waypoint(function () {
        const map = new GMaps({
          div: '#' + $mapD.attr('id'),
          scrollwheel: false,
          lat: $mapD.attr('map-lat'),
          lng: $mapD.attr('map-lng')
        })
        const marker = map.addMarker({
          lat: $mapD.attr('map-lat'),
          lng: $mapD.attr('map-lng'),
          title: $mapD.attr('map-title')
        })
        marker.setAnimation(google.maps.Animation.BOUNCE)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  }

}
